import angular from 'angular';

import ReportsService from './ReportsService';
import ReportsComponent from './ReportsComponent';
import HauledModalController from './HauledAwayModalController';
import DiaryComponent from './diary/DiaryComponent';
import dataKeysComponent from './diary/dataKeysComponent';
import DynamicEventsComponent from './dynamicEvents/DynamicEventsComponent';
import EventsComponent from './events/EventsComponent';
import FlowMeterComponent from './production/FlowMeterComponent';
import TanksComponent from './production/TanksComponent';
import LprComponent from './lprEvents/LprEventsComponent';

export default angular
  .module('petroCloud.reports', [
    'petroCloud.infoServices',
    'ui.grid.moveColumns',
    'ui.grid.infiniteScroll'
  ])
  .service('ReportsService', ReportsService)
  .controller('HauledModalController', HauledModalController)
  .component(ReportsComponent.name, ReportsComponent)
  .component(DiaryComponent.name, DiaryComponent)
  .component(dataKeysComponent.name, dataKeysComponent)
  .component(DynamicEventsComponent.name, DynamicEventsComponent)
  .component(EventsComponent.name, EventsComponent)
  .component(FlowMeterComponent.name, FlowMeterComponent)
  .component(TanksComponent.name, TanksComponent)
  .component(LprComponent.name, LprComponent)
  .name;
